import React from "react";
import { Calendar, Building } from "lucide-react";

const StepSelection = ({ onSelect }) => {
  return (
    <div className="flex flex-col items-center animate-in fade-in zoom-in duration-300 px-4">
      <h3 className="text-xl font-semibold text-slate-700 dark:text-slate-300 mb-8 text-center px-2">
        Please select the type of service you are looking for
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-2xl">
        {/* Appointment Option */}
        <button
          onClick={() => onSelect("appointment")}
          className="group relative flex flex-col items-center p-8 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 rounded-2xl hover:border-purple-500 dark:hover:border-purple-500 hover:shadow-xl transition-all duration-300 text-left"
        >
          <div className="p-4 bg-purple-50 dark:bg-purple-900/30 rounded-full mb-4 group-hover:scale-110 transition-transform duration-300">
            <Calendar className="w-8 h-8 text-purple-600 dark:text-purple-400" />
          </div>
          <h4 className="text-lg font-bold text-slate-900 dark:text-white mb-2">
            Book an Appointment
          </h4>
          <p className="text-sm text-slate-500 dark:text-slate-400 text-center">
            Schedule a tour of the facility or meet with our event planners.
          </p>
        </button>
        {/* Reservation Option */}
        <button
          onClick={() => onSelect("reservation")}
          className="group relative flex flex-col items-center p-8 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 rounded-2xl hover:border-blue-500 dark:hover:border-blue-500 hover:shadow-xl transition-all duration-300 text-left"
        >
          <div className="p-4 bg-blue-50 dark:bg-blue-900/30 rounded-full mb-4 group-hover:scale-110 transition-transform duration-300">
            <Building className="w-8 h-8 text-blue-600 dark:text-blue-400" />
          </div>
          <h4 className="text-lg font-bold text-slate-900 dark:text-white mb-2">
            Venue Reservation
          </h4>
          <p className="text-sm text-slate-500 dark:text-slate-400 text-center">
            Book Le Prestige Hall for your wedding, corporate event, or private
            party.
          </p>
        </button>
      </div>
    </div>
  );
};

export default StepSelection;
